import createModelStore from "../../../utils/createModelStore";
import Map from "../../services/Map";

const localObjectsGroup = createModelStore<
	Map.LocalObjectGroup,
	"localObjectGroups"
>("localObjectGroups");

export default localObjectsGroup;
